module.exports = __webpack_public_path__ + "img/coun.5ba70da0.svg";